import React from 'react';
import classNames from 'classnames';

interface ComponentProps {
  /** Any CSS colour. Passed through the `--tracker-swatch` custom property, which `.tracker-swatch` paints. */
  color: string;
  /** Extra classes, for example `tracker-swatch--heading` for a swatch inline with heading text. */
  className?: string;
}

/** The colour key square beside a legend label or category name. Decorative: the text beside it carries the meaning. */
const Swatch: React.FC<ComponentProps> = ({ color, className }) => (
  <span
    className={classNames('tracker-swatch', className)}
    style={{ '--tracker-swatch': color } as React.CSSProperties}
    aria-hidden="true"
  />
);

export default Swatch;
